import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OfferStates {
  [restaurant: string]: OfferStatus;
}

interface UserState {
  list: RestaurantFromAPI[] | null;
  timer: number;
  showClosestFirst: boolean;
  filterString: string;
  sorting: string;
  offerStates: OfferStates;
}

export const initialState: UserState = {
  list: null,
  timer: +new Date(),
  showClosestFirst: true,
  filterString: "",
  sorting: "status",
  offerStates: {}
};

const restaurantsSlice = createSlice({
  name: "restaurants",
  initialState,
  reducers: {
    requestRestaurants(state, action) {},
    setRestaurants(state, { payload }: PayloadAction<RestaurantFromAPI[]>) {
      state.list = payload;
    },
    setTime(state, { payload }: PayloadAction<number>) {
      state.timer = payload;
    },
    setShowClosestFirst(state, { payload }: PayloadAction<boolean>) {
      state.showClosestFirst = payload;
    },
    setFilterString(state, { payload }: PayloadAction<string>) {
      state.filterString = payload;
    },
    setSorting(state, { payload }: PayloadAction<string>) {
      state.sorting = payload;
    },
    setOfferStates(state, { payload }: PayloadAction<OfferStates>) {
      state.offerStates = payload;
    }
  }
});
const { actions, reducer } = restaurantsSlice;
export const {
  requestRestaurants,
  setRestaurants,
  setTime,
  setShowClosestFirst,
  setFilterString,
  setSorting,
  setOfferStates
} = actions;
export default reducer;
